export const CREATE_ACCOUNT_ROUTE = 'create/account';
export const ACCOUNT_LOGIN_ROUTE = 'in/login';
export const EMAIL_VERIFICATION_CTA_ROUTE = 'verify/email';
export const EMAIL_VERIFICATION_COMPLETE_ROUTE = 'verification/email/complete';
export const VERIFY_EMAIL_ROUTE = 'confirm/email';
export const RESET_PASSWORD_ROUTE = 'reset/password';
export const CHANGE_PASSWORD_ROUTE = 'change/password';
export const LOGIN_SUCCESSFUL_ROUTE = 'in/login/successful';
export const SIGNOUT_ROUTE = 'out/signout';
export const WORKSPACE_ROUTE = 'workspace';
export const WORKSPACE_GET_STARTED_ROUTE = 'get-started';
export const WORKSPACE_SETUP_ROUTE = 'setup';
export const EMAIL_KEY_CONSTANT = 'ee';
export const PRODUCT_KEY_CONSTANT = 'productName';
export const DESTINATION_KEY_CONSTANT = 'dst';
export const LOGIN_OBJECT_KEY_CONSTANT = 'lD';
export const PREVIOUS_DESTINATION_KEY_CONSTANT = 'pD';
export const DEFAULT_ROUTE_CONSTANT = ['/', ...CREATE_ACCOUNT_ROUTE.split('/')];
export const REDIRECTED_FLAG_CONSTANT = 'rf';
export const THIRD_PARTY_ROUTE = 'third-party';
export const THIRD_PARTY_GET_STARTED_ROUTE = 'get-started';
export const THIRD_PARTY_SETUP_ROUTE = 'setup';
export const CONSOLE_ROUTE = 'console';
export const CONSOLE_BASE_ROUTE = '';
export const AUDIT_ROUTE = 'audits';
export const REPORT_ROUTE = 'reports';
export const SELF_AUDIT_ROUTE = 'self';
export const AUDIT_LOAD_POINT_DISTRIBUTION = 'load-point-distribution';
export const SETTINGS_ROUTE = 'settings';
export const PROFILE_ROUTE = 'profile';
export const TEAM_MEMBERS_ROUTE = 'team-members';
export const COMPANY_DETAILS_ROUTE = 'company-details';
export const BILLINGS_ROUTE = 'billings';
export const BILLING_ACTIVITY_ROUTE = 'activity';
export const BILLING_PAYMENT_METHOD_ROUTE = 'payment-method';
export const BILLING_MONTHLY_COST_ROUTE = 'monthly-cost';
export const SITE = 'site';
export const EM = 'em';
export const CODE_KEY = 'code';
export const FRESH_FROM_SOURCE_CONSTANT = 'ffs';
export const CONTINUE_WITH_GOOGLE_SIGN_UP_ROUTE = 'create/account/continue-with-google';
export const CONTINUE_WITH_APPLE_SIGN_UP_ROUTE = 'create/account/continue-with-apple';
export const CONTINUE_WITH_GOOGLE_SIGN_IN_ROUTE = 'in/continue-with-google';
export const CONTINUE_WITH_APPLE_SIGN_IN_ROUTE = 'in/continue-with-apple';
export const CONSOLE_ASHAUDIT_BASE_ROUTE = 'ashaudit';
export const CONSOLE_ASHGRIDX_BASE_ROUTE = 'ashgridx';
export const CONSOLE_ASHGRIDX_VENDOR_ROUTE = 'vendors';
export const CONSOLE_ASHGRIDX_INVENTORY_ROUTE = 'inventory';
export const CONSOLE_ASHGRIDX_METER_ROUTE = 'meters';
export const CONSOLE_ASHGRIDX_CUSTOMER_METER_ROUTE = 'customer-meters';
export const CONSOLE_ASHGRIDX_BULK_METER_ROUTE = 'bulk-meters';
export const CONSOLE_ASHGRIDX_AGENT_ROUTE = 'agents';
export const CONSOLE_ASHGRIDX_METER_RECHARGE_ROUTE = 'meter-recharges';
export const CONSOLE_ASHGRIDX_PAYMENT_HISTORY_ROUTE = 'payment-history';
export const CONSOLE_SURECHARGEX_BASE_ROUTE = 'surechargex';
export const CONSOLE_SURECHARGEX_STATIONS_ROUTE = 'stations';
export const CONSOLE_SURECHARGEX_ADD_CHARGING_STATION_ROUTE = CONSOLE_SURECHARGEX_STATIONS_ROUTE + '/setup';
export const CONSOLE_SURECHARGEX_EDIT_CHARGING_STATION_ROUTE = CONSOLE_SURECHARGEX_STATIONS_ROUTE + '/edit';
export const CONSOLE_SURECHARGEX_VIEW_CHARGING_STATION_ROUTE = CONSOLE_SURECHARGEX_STATIONS_ROUTE + '/overview';
export const CONSOLE_SURECHARGEX_BOOKINGS_ROUTE = 'bookings';
export const CONSOLE_SURECHARGEX_PAYMENTS_ROUTE = 'payments';
export const CONSOLE_SURECHARGEX_USERS_ROUTE = 'users';
export const CONSOLE_SURECHARGEX_ANALYTICS_ROUTE = 'analytics';
export const CONSOLE_MANAGE_PRIVILEGE_ROUTE = TEAM_MEMBERS_ROUTE + '/' + 'privilege/view';
export const CONSOLE_ADD_PRIVILEGE_ROUTE = TEAM_MEMBERS_ROUTE + '/' + 'privilege/add';
export const CONSOLE_NO_WORKSPACE_ROUTE = 'no-workspace';
export const CONNECTORS = 'connectors';
export const CONNECTORS_ROUTE = CONSOLE_SURECHARGEX_BASE_ROUTE + '/' + CONNECTORS;
export const AMENITIES = 'amenities';
export const AMENITIES_ROUTES = CONSOLE_SURECHARGEX_BASE_ROUTE + '/' + AMENITIES;
